import React, { useState, useEffect } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-1.svg";
import { useTranslation } from "react-i18next";
import image1 from "images/image1.jpg";
import image2 from "images/image2.jpg";
import image3 from "images/image3.jpg";
import image4 from "images/imageLABO-01.png";
import image01 from "images/image01.png";
import image02 from "images/01.png";
import image03 from "images/03.png";
import image04 from "images/03.png";
import image05 from "images/04.png";
import visage from "images/01.png";

const Container = styled.div`
  position: relative;
  width: calc(100% + 200px);
  min-height: 600px;
  margin-left: -100px;
  margin-right: -100px;
  margin-top: 30px;
  ${tw`flex items-center`}
  background: ${({ bg }) => `url(${bg}) center center / cover no-repeat`};
  transition: background-image 1s ease-in-out;

  /* ✅ Mobile-only override */
  @media (max-width: 768px) {
    position: relative;
    width: 100vw;
     height:600px;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    min-height: 500px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    padding-bottom: 50px;
  }
`;
const TwoColumn = tw.div`flex flex-col lg:flex-row items-center max-w-screen-xl mx-auto py-20 md:py-24`;
const RightColumn = styled.div`
  ${tw`
    relative
    lg:w-6/12
    lg:pl-12
    flex
    flex-col
    items-start
    justify-center
    text-left
    mt-10
    lg:mt-0
    px-4
    mr-[500px]
  `}

  /* ✅ Center content on mobile */
  @media (max-width: 768px) {
    margin-right: 0;
    margin-top: -220px;
    padding: 0 20px;
    align-items: center;       /* Center horizontally */
    text-align: center;        /* Center text */
    justify-content: center;   /* Center vertically */
    height: 100%;              /* Fill section height */
  }
`;

const Heading = tw.h1`
  font-black
  text-[2.5rem]
  md:text-5xl
  leading-tight
  max-w-3xl
  text-white
  whitespace-nowrap
  mb-2
`;

const Paragraph = tw.p`
  my-5
  lg:my-8
  text-sm
  lg:text-base
  font-medium
  text-white
  max-w-lg
  mx-0
  lg:mx-0
`;
const Actions = tw.div`flex flex-col items-center sm:flex-row justify-center lg:justify-start mt-8`;
const PrimaryButton = tw.a`
  font-bold px-8 lg:px-10 py-3 
  rounded-full 
  bg-[#4e7662] text-gray-100 
  hocus:bg-[#4e7662] 
  focus:shadow-outline focus:outline-none 
  transition duration-300
`;
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none opacity-5 absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3  -z-10`}
`;
const ButtonIcon = tw(FontAwesomeIcon)`mr-2`; // Adds margin to the right of the icon

export default ({
}) => {
    const { t } = useTranslation();
    const slides = [
  {
   image: image1, // 🖥️ desktop version
    mobileImage: visage , // 📱 mobile version
    title: t("slide.haircare.title"),
    text: t("slide.haircare.text"),
    buttonUrl: "https://rehabbio.ma/boutique",
  },
  {
   image: image3, // 🖥️ desktop version
    mobileImage: image02, // 📱 mobile version
    title: t("slide.routinecare.title"),
    text: t("slide.routinecare.text"),
    buttonUrl: "https://rehabbio.ma/boutique",
  },
  {
   image: image2, // 🖥️ desktop version
    mobileImage: image03, // 📱 mobile version
    title: t("slide.intimecare.title"),
    text: t("slide.intimecare.text"),
    buttonUrl: "https://rehabbio.ma/boutique",
  },
  {
    image: image01, // 🖥️ desktop version
    mobileImage: image05, // 📱 mobile version
    title: t("slide.labo.title"),
    text: t("slide.labo.text"),
    buttonUrl: "https://rehabbio.ma/boutique",
  },
];
  const [current, setCurrent] = useState(0);
const [isMobile, setIsMobile] = useState(false);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  handleResize(); // check immediately
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000); // Change image every 4 seconds
    return () => clearInterval(interval);
  }, []);


  return (
<Container
  bg={
    slides[current].mobileImage && isMobile
      ? slides[current].mobileImage
      : slides[current].image
  }
>
  <TwoColumn>
    <RightColumn>
      {/* Only render these if the slide has text/title/button */}
      {slides[current].title && <Heading>{slides[current].title}</Heading>}
      {slides[current].text && <Paragraph>{slides[current].text}</Paragraph>}
      {slides[current].buttonUrl && (
        <Actions>
          <PrimaryButton
            href={slides[current].buttonUrl}
            style={{ marginTop: "-30px" }}
          >
            <ButtonIcon />
            {t("Découvrez")} &rarr;
          </PrimaryButton>
        </Actions>
      )}
    </RightColumn>
  </TwoColumn>
  <DecoratorBlob1 />
</Container>
  );
};
